import { useCart } from '@corratech/pylot-cart-manager'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTrackCheckoutStep } from '../hooks'
import { CheckoutStepNameEnum } from '@config/seo/checkoutSteps'
import { CHECKOUT_PAGE_ROUTE } from './useTrackCheckoutPageStep'
import { parseUrlPathName } from '../utils/parseUrlPathName'

export const useTrackPaymentMethod = (): null => {
    const { isFallback, asPath } = useRouter()
    const trackCheckoutStep = useTrackCheckoutStep()
    const { data, isValidating } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const isOptimistic = data?.data?.isOptimistic
    useEffect(() => {
        const methodTitle = cart?.selected_payment_method?.title
        if (
            methodTitle &&
            !isFallback &&
            !isOptimistic &&
            !isValidating &&
            parseUrlPathName(asPath) === CHECKOUT_PAGE_ROUTE
        ) {
            trackCheckoutStep({
                step: CheckoutStepNameEnum.PAYMENT,
                option: methodTitle
            })
        }
    }, [cart, isFallback, isValidating, isOptimistic])

    return null
}
